import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { Modal } from 'ionic-angular';
import { ModalProvider } from './popup/modal';

const INSPECTOR_BUSY_MODAL_NAME = 'InspectorBusyModal';

@Injectable()
export class InspectorBusyProvider extends BaseProvider {
    private inspectorBusyModal: Modal | undefined;

    constructor(private modalProvider: ModalProvider) {
        super();
    }

    public async showBusyModal(): Promise<void> {
        if (this.modalProvider.modalIsOpen(INSPECTOR_BUSY_MODAL_NAME)) {
            return;
        }

        this.inspectorBusyModal = this.modalProvider.createModal(
            INSPECTOR_BUSY_MODAL_NAME,
            {},
            {
                cssClass: 'inspector-busy-page',
                enableBackdropDismiss: false
            }
        );

        await this.inspectorBusyModal.present();
    }

    public async dismissBusyModal(): Promise<void> {
        if (!this.modalProvider.modalIsOpen(INSPECTOR_BUSY_MODAL_NAME)) {
            return;
        }

        if (this.inspectorBusyModal) {
            await this.inspectorBusyModal.dismiss();
        }
    }
}



// WEBPACK FOOTER //
// ./src/providers/inspector-busy.ts